import Vue from 'vue'
import App from './App'
import router from './router'
import "mint-ui/lib/style.css"
import Mint from "mint-ui";
import {Toast, MessageBox, Loadmore} from "mint-ui";
import VueWechatTitle from 'vue-wechat-title'
import clipboard from 'clipboard';
import "./assets/css/reset.css";
import "./assets/js";
import "./api";
import fastclick from 'fastclick';
import 'swiper/css/swiper.css';
import animated from 'animate.css' // npm install animate.css --save安装，在引入

// import { getAppUserInfo } from '../src/config/appGet'
// Vue.use(Swiper);

Vue.component(Loadmore.name, Loadmore);
Vue.use(animated)
Vue.use(VueWechatTitle)
Vue.use(Mint);
Vue.prototype.Toast = Toast;
Vue.prototype.Clipboard = clipboard;
Vue.prototype.MessageBox = MessageBox;

fastclick.prototype.focus = function (targetElement) {
  var length;
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};

fastclick.prototype.onTouchStart = function (event) {
  var targetElement, touch, selection;
  if (event.targetTouches.length > 1) {
    return true;
  }

  targetElement = this.getTargetElementFromEventTarget(event.target);
  touch = event.targetTouches[0];
  var nodeName = targetElement.nodeName.toLowerCase();
  if (nodeName === "select") {
    return false;
  }
}

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    fastclick.attach(document.body)
  }, false)
}
window.onbeforeunload = () => {
  localStorage.removeItem('tokenInfo');
}
new Vue({
  render: h => h(App),
  router
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js